// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2e_Nd","content":"styles_content__35lFa"};